export default __webpack_public_path__ + "static/SRUS OC234 - Product Specifications & Technical Data-d06ab2af772eae6d82fe5de30a4f6c5d.pdf";